import { PropsWithChildren, useRef } from 'react';

import { createValidationStore, ValidationContext, ValidationProps, ValidationStore } from './validationStore';

type ValidationProviderProps = PropsWithChildren<Partial<ValidationProps>>;

export const ValidationProvider = ({ children }: ValidationProviderProps) => {
  const storeRef = useRef<ValidationStore>(null);

  if (!storeRef.current) {
    storeRef.current = createValidationStore({
      recentlyCompleted: [],
      tableViewIsHidden: true,
    });
  }

  return <ValidationContext.Provider value={storeRef.current}>{children}</ValidationContext.Provider>;
};
